<script setup lang="ts">
import { NConfigProvider, NDialogProvider, NLoadingBarProvider, NMessageProvider, NNotificationProvider } from "naive-ui";
import type { Component } from "vue";
import { RouterView, useRoute } from "vue-router";
import { useThemeStore } from "../stores/themeStore";
import ExposeNaiveUIWidget from "./ExposeNaiveUIWidget.vue";

const themeStore = useThemeStore();
const route = useRoute();

// Props untuk menerima layout component dan status app siap/belum (isReady)
const props = withDefaults(
  defineProps<{
    layout?: Component | string;
    isReady?: boolean;
    isLoading?: boolean;
  }>(),
  {
    layout: "div",
    isReady: false,
    isLoading: false,
  },
);
</script>

<template>
  <n-config-provider :theme="themeStore.theme" :theme-overrides="themeStore.themeOverrides">
    <n-notification-provider :max="3">
      <n-message-provider :max="3" placement="top">
        <n-loading-bar-provider>
          <n-dialog-provider>
            <ExposeNaiveUIWidget>
              <n-spin :show="isLoading">
                <div v-if="isReady" class="h-full overflow-hidden">
                  <component :is="layout">
                    <!--
                      PENTING: key pakai route.path (bukan route.fullPath).
                      fullPath ikut menyertakan query string (mis. ?t=...), jadi kalau
                      dipakai sebagai key, setiap perubahan query param (misalnya
                      persist tab aktif) akan dianggap route/komponen BERBEDA oleh Vue,
                      sehingga komponen di-destroy & di-mount ulang total (semua
                      onBeforeMount/fetch data jalan lagi) dan keep-alive jadi tidak
                      efektif karena cache key-nya selalu baru.
                      Dengan route.path, komponen hanya di-remount saat path benar-benar
                      berubah (mis. pindah halaman / ganti :id), bukan saat query saja
                      yang berubah.
                    -->
                    <RouterView :key="route?.path" v-slot="{ Component }">
                      <keep-alive>
                        <component :is="Component" :key="route?.path" />
                      </keep-alive>
                    </RouterView>
                  </component>
                </div>
                <slot v-else></slot>
              </n-spin>
            </ExposeNaiveUIWidget>
          </n-dialog-provider>
        </n-loading-bar-provider>
      </n-message-provider>
    </n-notification-provider>
  </n-config-provider>
</template>
